import { ReactElement } from 'react';
import {
  TabbedForm,
  TextInput,
  maxLength,
  TabbedFormViewProps,
  useCanAccess,
  required,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';
import JsonApiHasOneReferenceInput from '../../../Components/JsonApiHasOneReferenceInput';
import { MerchantResource } from '../../../Entities/Merchant';
import { createFilterQuery } from '../../../utils';

export default function AddressTab(props: TabbedFormViewProps): ReactElement {
  const countriesAccess = useCanAccess({ resource: 'countries', action: 'list' });
  const canListCountries = countriesAccess.canAccess ?? false;

  return (
    <TabbedForm.Tab label="Address" {...props}>
      <TextInput label="Street Address" source="attributes.address" validate={maxLength(255)} />
      <JsonApiHasOneReferenceInput<MerchantResource, 'state'>
        label="State"
        defaultValue="0"
        optionText="attributes.name"
        reference="states"
        source="relationships.state"
        isRequired
        validate={required()}
      />
      <TextInput label="Post Code" source="attributes.postal_code" validate={maxLength(50)} />
      <TextInput label="City" source="attributes.city" validate={maxLength(50)} />
      {canListCountries && (
        <ReferenceInput
          defaultValue="Australia"
          label="Country"
          source="attributes.country_name"
          target="attributes.name"
          reference="countries"
          perPage={1000}
          sort={{ field: 'attributes.name', order: 'ASC' }}
        >
          <AutocompleteInput
            filterToQuery={createFilterQuery()}
            label="Country"
            optionText="attributes.name"
            optionValue="attributes.name"
            defaultValue="Australia"
            isRequired
            validate={required()}
          />
        </ReferenceInput>
      )}
    </TabbedForm.Tab>
  );
}
